module.exports = {"id":"158394","name":"Ken Reichel","rating":"72","photo":"./data/images/photos/2/158394.png","club":{"name":"Eint. Brunswick","logo":"./data/images/clubs/Eint.Brunswick.png"},"positions":["DG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KenReichel0.json
// module id = 2319
// module chunks = 0